import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { noop } from 'lodash';
import KubitModal from '../KubitModal';
import { Loader } from '../Loaders';
import { GET_SCHEDULE } from '../../utils/apollo/scheduler/query';
import SchedulerLoadedForm from './SchedulerLoadedForm'; // The new split-out component
import { useSelector } from 'react-redux';
import { selectModalData } from '../../redux/selectors/modal';
import {
  IGetScheduleQuery,
  IGetScheduleQueryVariables,
  IScheduleFieldsFragment,
  IScheduleHistoryFieldsFragment,
  ScheduleType,
} from '../../utils/apollo/graphqlSchema';

interface IProps {
  entityId?: string;
  jobType: ScheduleType;
  recurringOnly?: boolean;
  prefilledName?: string;
  isStaticDateRangeCohort?: boolean;
  currentSchedule?:
    | (IScheduleFieldsFragment & IScheduleHistoryFieldsFragment)
    | null;
  ignoreModalData?: boolean;
}

export default function Scheduler({
  entityId,
  jobType,
  prefilledName,
  recurringOnly = false,
  isStaticDateRangeCohort,
  ignoreModalData = false,
}: IProps) {
  // Extract schedule from modal data if applicable
  const modalDataSchedule = useSelector(selectModalData);
  const modalSchedule = useMemo(
    () =>
      !ignoreModalData
        ? (modalDataSchedule as IScheduleFieldsFragment &
            IScheduleHistoryFieldsFragment)
        : undefined,
    [ignoreModalData, modalDataSchedule],
  );

  const currentScheduleId = modalSchedule?.id;

  // Loading schedule by id
  const { loading, data } = useQuery<
    IGetScheduleQuery,
    IGetScheduleQueryVariables
  >(GET_SCHEDULE, {
    variables: { scheduleId: currentScheduleId! },
    skip: !currentScheduleId,
  });

  const schedule = data?.scheduleGet;

  if (loading && modalSchedule) {
    return (
      <KubitModal header="Loading schedule...." onClose={noop} open>
        <Loader />
      </KubitModal>
    );
  } else {
    return (
      <SchedulerLoadedForm
        jobType={jobType}
        entityId={entityId}
        isStaticDateRangeCohort={isStaticDateRangeCohort}
        recurringOnly={recurringOnly}
        prefilledName={prefilledName}
        currentSchedule={schedule}
      />
    );
  }
}
